import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('SUPPLIER SERVICE');

@Injectable({
  providedIn: 'root'
})
export class SupplierService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'suppliers' como el nombre del recurso a la clase base
    super('suppliers');
    log.debug('Servicio de Proveedor inicializado');
  }

}
